var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGridBordered = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 5H5V6.5H6.5V5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 5H11V6.5H9.5V5Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 5H7.25V6.5H8.75V5Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M5 7.25H6.5V8.75H5V7.25Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 7.25H9.5V8.75H11V7.25Z",
  fill: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.25 7.25H8.75V8.75H7.25V7.25Z",
  fill: "currentColor"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 9.5H5V11H6.5V9.5Z",
  fill: "currentColor"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 9.5H11V11H9.5V9.5Z",
  fill: "currentColor"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 9.5H7.25V11H8.75V9.5Z",
  fill: "currentColor"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3ZM3.5 12.5V3.5H12.5V12.5H3.5Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGridBordered);
export default ForwardRef;